import { type FC, type ReactNode, type RefObject, type UIEventHandler } from 'react';

interface SidePanelInitialContentProps {
  children: ReactNode;
  wrapperRef: RefObject<HTMLDivElement | null>;
  onScrollCapture: UIEventHandler<HTMLDivElement>;
}

const SidePanelInitialContent: FC<SidePanelInitialContentProps> = ({
  children,
  wrapperRef,
  onScrollCapture,
}) => {
  return (
    <div
      className="flex-1 flex flex-col overflow-hidden"
      ref={wrapperRef}
      onScrollCapture={onScrollCapture}
    >
      {children}
    </div>
  );
};

export default SidePanelInitialContent;
